import { useMemoizedFn } from "ahooks";
import React from "react";
import { log } from "@/utils/log";

interface BrokenAppPlaceholderProps {
    appId: string;
    // Omitted when retrying cannot help (e.g. the app is not installed), which hides the Retry button.
    onRetry?: () => void;
    message?: string;
    style?: { height?: number };
}

export const BrokenAppPlaceholder = ({
    appId,
    onRetry,
    message = "App failed to load.",
    style,
}: BrokenAppPlaceholderProps) => {
    const handleReport = useMemoizedFn(() => log("User reported broken embedded app", { appId }));

    return (
        // style carries the measured canvas height from ColumnLayout.Fill, which Tailwind cannot express.
        <div className="flex h-full flex-col items-center justify-center gap-3 p-6 text-center" style={style}>
            <p className="text-sm text-gray-dark">{message}</p>
            <div className="flex gap-2">
                {onRetry && (
                    <button
                        type="button"
                        className="rounded border border-gray-light bg-white px-3 py-1.5 text-sm hover:bg-gray-hover"
                        onClick={onRetry}
                    >
                        Retry
                    </button>
                )}
                <button
                    type="button"
                    className="rounded border border-gray-light bg-white px-3 py-1.5 text-sm hover:bg-gray-hover"
                    onClick={handleReport}
                >
                    Report
                </button>
            </div>
        </div>
    );
};
